import type { StockBalanceId, StoreId } from "@KassaroAB/shared/types/ids";
import type { RestGetCostPool } from "@KassaroAB/shared/types/costPool";
import { api } from "../utils/api";

export const getCostPoolApi = async (
  storeId: StoreId,
  poolKey: string,
  skuKey: StockBalanceId,
): Promise<RestGetCostPool> =>
  api.get(
    `stores/${storeId}/inventoryCosting/pools/${encodeURIComponent(poolKey)}/${encodeURIComponent(skuKey)}`,
  );
